import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { FeatureID } from 'src/app/moov-common/enum/feature.enum';
import { Gender } from 'src/app/moov-common/enum/gender.enum';
import { Locale } from 'src/app/moov-common/enum/locale.enum';
import { GenderPipe } from 'src/app/moov-common/pipes/gender.pipe';
import { DiscoveryStatusEnum } from 'src/app/moov-common/services/personal-user-data/personal-user-data';
import { AbstractPersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.abstract.service';
import { NAVIGATION_ROUTES } from 'src/app/navigation-routes.const';

@Component({
  selector: 'app-first-time-login',
  templateUrl: './first-time-login.component.html',
  styleUrls: ['./first-time-login.component.scss']
})
export class FirstTimeLoginComponent extends BaseComponent implements OnInit {

  imageRootFolder = "assets/common/";
  discoveryAssetsFolder = "assets/discovery/";
  videoAssetsFolder = 'assets/media/questions/';
  presentChatIntro = false;
  introVideoAssetName : string = "";
  public approvePrivaceyPolicyCheckbox: boolean = false;
  bfirstTimeLoginSecondPhase : boolean = false;
  presentConsultantVideo: boolean = false;
  isVideoMuted : boolean = false;
  introText: string = "";
  showMoreDetailsButtonHeader : string = "";
  showMoreTextDetails : boolean = false;
  @ViewChild('introVideo') introVideo: ElementRef;

  constructor(private router: Router, 
              private http: HttpClient, 
              private readonly userService: AbstractPersonalUserDataService,
              private readonly translate: TranslateService,
              private genderSerivce: GenderPipe,
              private readonly personalUserService: AbstractPersonalUserDataService) { 
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    if (this.user?.discoveryStatus == DiscoveryStatusEnum.DONE){
      // the user has navigated here by mistake
      this.router.navigate([NAVIGATION_ROUTES.app.personalView]);
    }

    this.introVideoAssetName = this.utilsService.buildVideoNameByGenderAndLocale(this.videoAssetsFolder + 'intro', '.mp4', this.user!);

    if (!this.shouldApprovePrivacyPolicyBePresented()){
      this.approvePrivaceyPolicyCheckbox = true;
    }

    this.verifyPresentQuestionsVideos();
    this.calculateMessageText();
  }

  ngAfterViewInit() {
    // this.calculateMessageText();
  }

  verifyPresentQuestionsVideos(): void{
    this.personalUserService.verifyFeature(FeatureID.discoveryConsultantQuestionsVideos).subscribe(res => {
      this.presentConsultantVideo = res;
    });
  }

  goToNextPhase(): void{
    if (this.user?.discoveryStatus == DiscoveryStatusEnum.DIDNT_START){
      // this is the first time the user i meeting the questioner - present intro
      // console.log ("in ftl goToDicovery status is didnt start");
      this.presentChatIntro = true;
    }
    else{
      // console.log ("in ftl goToDicovery status is NOT didnt start");
      this.routeToDiscovery();
    }
  }

  routeToDiscovery(): void{
    if (!this.bfirstTimeLoginSecondPhase && this.isMobileView){
      //only present the next window
      this.bfirstTimeLoginSecondPhase = true;
      return;
    }

    const gaActionLabel = this.user?.discoveryStatus == DiscoveryStatusEnum.DIDNT_START ? "start_discovery":"continue_discovery";
    // this.analytics.send(GAEventsCategories.Discovery, "discovery_state", gaActionLabel, "", {"userMail":this.user?.mailAddress});

    if (this.user?.discoveryStatus == DiscoveryStatusEnum.DIDNT_START){
      this.analytics.discoveryProcessStartedEvent();
    } else {
      this.analytics.discoveryProcessResumedEvent();
    }
    this.userService.approvePrivacyPolicy().subscribe(res => {
        // console.log(`after call to approvePrivacyPolicy `);
        this.router.navigate([NAVIGATION_ROUTES.app.dicovery]);
    });
  }

  shouldApprovePrivacyPolicyBePresented(): boolean{
    return this.user?.discoveryStatus == DiscoveryStatusEnum.DIDNT_START;
  }

  canUserStartDiscovery(): boolean{
    return !this.approvePrivaceyPolicyCheckbox;
  }

  goToPrivacyStatement(): void{

    let privacyUrl : string = "";

    if (this.user?.locale == Locale.he_IL){
      privacyUrl = '/assets/static/privacy/he/Claro_Privay_Policy.htm';
    }
    else{
      privacyUrl = '/assets/static/privacy/en/Claro_Privay_Policy.htm';
    }

    window.open(privacyUrl);
  }

  playVideo(): void{
    if (!this.presentConsultantVideo){
      return;
    }

    const media = this.introVideo.nativeElement;
    if (this.isVideoMuted){
      media.muted = true;
    }
    else{
      media.muted = false;
    }

    media.play();
  }

  muteConsultantVideo() : void{
    this.isVideoMuted = !this.isVideoMuted;
  
    const media = this.introVideo.nativeElement;
    if (this.isVideoMuted){
      media.muted = true;
      this.analytics.UserMutedQuestionVideo();
    }
    else{
      media.muted = false;
      this.analytics.UserUnMutedQuestionVideo();
    }
  }

  toggleShowMoreText(){
    this.showMoreTextDetails = !this.showMoreTextDetails;
    this.calculateMessageText();
  }

  calculateMessageText(){
     this.translate.stream(this.genderSerivce.transform("firstTime.messageText")).subscribe(fullMessageText => {

      const messageTextCutOut = this.translate.instant("firstTime.messageTextCutOut");
      const index = fullMessageText.indexOf( messageTextCutOut ) + messageTextCutOut.length;
  
      if (this.showMoreTextDetails){
        this.showMoreDetailsButtonHeader = this.translate.instant( "common.showLessTextLabel");
        this.introText = fullMessageText
        // console.log(`in calculateMessageText FULL details intro text is ${this.introText}`);
      } 
      else{
        this.showMoreDetailsButtonHeader = this.translate.instant("common.showMoreTextLabel");
        this.introText =fullMessageText.substring(0, index);
  
        // console.log(`in calculateMessageText PARTIAL details intro text is ${this.introText}`);
        if (this.introText.length < fullMessageText.length ){
          this.introText += "...";
        }
  
        // console.log(`in calculateMessageText text length details intro text is ${this.introText.length.toString()}`);
      }
  
     });
    }
}
